import styled, { css } from 'styled-components';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';

export const FixedContainer = styled.div`
    display: flex;
    position: relative;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100vh;
    background-color: ${p => p.bgColor ? p.bgColor : 'transparent'};
    overflow: hidden;
    @media(max-width: 985px) {
        flex-derection: column;
        height: auto;
        padding: 130px 0 70px;
    }
    @media(max-width: 720px) {
        padding: 95px 0 40px;
    }
`;

export const Wrapper = styled.div`
    display: block;
    width: 100%;
    color: ${p => p.textColor ? p.textColor : COLORS.white};
    margin-bottom: -50px;
`;

export const BgImage = styled.div`
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 100%;
    background-image: url(${p => p.image ? p.image : 'none'});
    background-size: cover;
    background-position: 100% 100%;
    background-repeat: no-repeat;
    @media screen and (max-width: 1599px) {
        background-position: 50% 100%;
    }
    @media (max-width: 600px) {
        background-position: 73% 100%;
    }
    @media (max-width: 530px) {
        background-image: url(${p => p.hiddenImageForMobile ? 'none' : p.image});
        opacity: .5;
    }
`;

export const BgImageRight = styled(BgImage)`
    display: block;
    position: absolute;
    top: 50%;
    right: 0;
    height: 70%;
    width: 50%;
    background-image: url(${p => p.image ? p.image : 'none'});
    background-size: contain;
    background-position: 50% 50%;
    transform: translateY(-50%);
    background-repeat: no-repeat;
    @media screen and (max-width: 1599px) {
        background-position: 50% 100%;
    }
    @media (max-width: 600px) {
        background-position: 73% 100%;
    }
    @media (max-width: 530px) {
        background-image: url(${p => p.hiddenImageForMobile ? 'none' : p.image});
        opacity: .5;
    }
`;

export const RequestBgImage = styled(BgImage)`
    background-size: auto 100%;
    background-position: right 100%;
    ${p => p.customStyle && css`${p.customStyle}`};
`;
